import instance from './instance.js';
import { Loading, Message, MessageBox } from 'element-ui';
import EFormat from '@/utils/EFormat.js';

const Y = {};

Y.isOpenApi = true;
Y.env = process.env;
Y.Req = instance;
Y.API_PATH = Y.env.NODE_ENV == 'development' ? Y.env.VUE_APP_LHOST : Y.env.VUE_APP_BASE_API;

// 微信登录配置
Y.wechat = {};
Y.wechat.isSeting = false;
Y.wechat._config = {
	// true 在iframe中跳转，false直接跳转
	self_redirect: true,

	// 加密的APPID
	appid: 'wx7b666dee4d4c92b1',

	// 应用授权作用域，扫码登录固定为snsapi_login
	scope: 'snsapi_login',

	// 回调地址（需编码）
	redirect_uri: '',

	// 用于保持请求和回调的状态，可任意填写
	state: 'window.location.href', // window.location.href, // 'STATE',

	// 二维码样式（black/white）
	style: 'black',

	// 自定义样式链接（可选）
	href: '',

	stylelite: 1,

	login_type: 'jssdk'
};

// 获得配置信息
Y.wechat.config = function () {
	let config = Y.wechat._config;

	// 处理配置信息
	if (!Y.wechat.isSeting) {
		// config.appid = EFormat.decrypt(config.appid);
		Y.wechat.isSeting = true;
	}

	return config;
};
// 提示消息
Y.alert = async function (msg, title, option) {
	title = title || '提示';
	option = option || {};

	let roption = {};
	roption.confirmButtonText = option.confirmButtonText || '确定';

	if (option.center) {
		roption.center = true;
	}

	if (typeof option.callback == 'function') {
		roption = option.callback;
	}

	let rlt = {
		confirm: false,
		cancel: false
	};

	try {
		let res = await MessageBox.alert(msg, title, roption);

		rlt.confirm = true;
		return rlt;
	} catch (err) {
		rlt.cancel = true;
		return rlt;
	}

	return;
};

// 确认消息
Y.confirm = async function (msg, title, option) {
	title = title || '提示';
	option = option || {};

	let roption = {};
	roption.confirmButtonText = option.confirmButtonText || '确定';
	roption.cancelButtonText = option.cancelButtonText || '取消';
	roption.type = option.type || 'warning';

	if (option.center) {
		roption.center = true;
	}

	if (typeof option.callback == 'function') {
		roption = option.callback;
	}

	let rlt = {
		confirm: false,
		cancel: false
	};

	try {
		let res = await MessageBox.confirm(msg, title, roption);

		rlt.confirm = true;
		return rlt;
	} catch (err) {
		rlt.cancel = true;
		return rlt;
	}
};

Y.hloading = null;

Y.loading = function (msg, rang) {
	msg = msg || '加载中...';
	rang = rang || 1300;

	Y.hloading = Loading.service({
		text: msg,
		customClass: 'sys-loading'
	});

	setTimeout(() => {
		Y.hloading.close();
	}, rang);
};

Y.msg = {};

// 成功信息
Y.msg.success = function (msg) {
	Message({ message: msg, showClose: true, type: 'success' });
};

// 警告消息
Y.msg.warning = function (msg) {
	Message({ message: msg, showClose: true, type: 'warning' });
};

// 警告消息
Y.msg.error = function (msg) {
	Message({ message: msg, showClose: true, type: 'error' });
};

// 普通消息
Y.msg.info = function (msg) {
	Message({ message: msg, showClose: true, type: 'info' });
};

export default Y;
